import {
  INVOICE_DRAFT_LIST_REQUEST,
  INVOICE_DRAFT_LIST_SUCCESS,
  INVOICE_DRAFT_LIST_FAILURE,
  INVOICE_DRAFT_SEARCH_REQUEST,
  INVOICE_DRAFT_SEARCH_SUCCESS,
  INVOICE_DRAFT_SEARCH_FAILURE,
  INVOICE_DRAFT_CREATE_REQUEST,
  INVOICE_DRAFT_CREATE_SUCCESS,
  INVOICE_DRAFT_CREATE_FAILURE,
  INVOICE_DRAFT_UPDATE_REQUEST,
  INVOICE_DRAFT_UPDATE_SUCCESS,
  INVOICE_DRAFT_UPDATE_FAILURE,
  INVOICE_DRAFT_VOID_REQUEST,
  INVOICE_DRAFT_VOID_SUCCESS,
  INVOICE_DRAFT_VOID_FAILURE,
  INVOICE_DRAFT_PDF_REQUEST,
  INVOICE_DRAFT_PDF_SUCCESS,
  INVOICE_DRAFT_PDF_FAILURE,
  INVOICE_DRAFT_DAILY_BALANCE_REQUEST,
  INVOICE_DRAFT_DAILY_BALANCE_SUCCESS,
  INVOICE_DRAFT_DAILY_BALANCE_FAILURE,
  INVOICE_DRAFT_STATUS_LIST_REQUEST,
  INVOICE_DRAFT_STATUS_LIST_SUCCESS,
  INVOICE_DRAFT_STATUS_LIST_FAILURE,
  INVOICE_DRAFT_STATUS_DATA_REQUEST,
  INVOICE_DRAFT_STATUS_DATA_SUCCESS,
  INVOICE_DRAFT_STATUS_DATA_FAILURE,
  INVOICE_DRAFT_STATUS_CREATE_REQUEST,
  INVOICE_DRAFT_STATUS_CREATE_SUCCESS,
  INVOICE_DRAFT_STATUS_CREATE_FAILURE,
  INVOICE_DRAFT_STATUS_UPDATE_REQUEST,
  INVOICE_DRAFT_STATUS_UPDATE_SUCCESS,
  INVOICE_DRAFT_STATUS_UPDATE_FAILURE,
  INVOICE_DRAFT_STATUS_DELETE_REQUEST,
  INVOICE_DRAFT_STATUS_DELETE_SUCCESS,
  INVOICE_DRAFT_STATUS_DELETE_FAILURE,
  INVOICE_DRAFT_DATA_REQUEST,
  INVOICE_DRAFT_DATA_SUCCESS,
  INVOICE_DRAFT_DATA_FAILURE,
  INVOICE_DRAFT_ACTIVITY_LOG_SEARCH_REQUEST,
  INVOICE_DRAFT_ACTIVITY_LOG_SEARCH_SUCCESS,
  INVOICE_DRAFT_ACTIVITY_LOG_SEARCH_FAILURE,
  INVOICE_DRAFT_CONVERT_TO_INVOICE_REQUEST,
  INVOICE_DRAFT_CONVERT_TO_INVOICE_SUCCESS,
  INVOICE_DRAFT_CONVERT_TO_INVOICE_FAILURE,
} from "./actionType";

//INVOICE_DRAFT_LIST_REQUEST
export const invoiceDraftListRequest = () => {
  return {
    type: INVOICE_DRAFT_LIST_REQUEST,
  };
};
//INVOICE_DRAFT_LIST_SUCCESS
export const invoiceDraftListSuccess = (data) => {
  return {
    type: INVOICE_DRAFT_LIST_SUCCESS,
    payload: data,
  };
};
//INVOICE_DRAFT_LIST_FAILURE
export const invoiceDraftListFailure = (error) => {
  return {
    type: INVOICE_DRAFT_LIST_FAILURE,
    payload: error,
  };
};
//INVOICE_DRAFT_SEARCH_REQUEST
export const invoiceDraftSearchRequest = (data) => {
  return {
    type: INVOICE_DRAFT_SEARCH_REQUEST,
    payload: data,
  };
};
//INVOICE_DRAFT_SEARCH_SUCCESS
export const invoiceDraftSearchSuccess = (data) => {
  return {
    type: INVOICE_DRAFT_SEARCH_SUCCESS,
    payload: data,
  };
};
//INVOICE_DRAFT_SEARCH_FAILURE
export const invoiceDraftSearchFailure = (error) => {
  return {
    type: INVOICE_DRAFT_SEARCH_FAILURE,
    payload: error,
  };
};
//INVOICE_DRAFT_CREATE_REQUEST
export const invoiceDraftCreateRequest = (data) => {
  return {
    type: INVOICE_DRAFT_CREATE_REQUEST,
    payload: data,
  };
};
//INVOICE_DRAFT_CREATE_SUCCESS
export const invoiceDraftCreateSuccess = (data) => {
  return {
    type: INVOICE_DRAFT_CREATE_SUCCESS,
    payload: data,
  };
};
//INVOICE_DRAFT_CREATE_FAILURE
export const invoiceDraftCreateFailure = (error) => {
  return {
    type: INVOICE_DRAFT_CREATE_FAILURE,
    payload: error,
  };
};
//INVOICE_DRAFT_UPDATE_REQUEST
export const invoiceDraftUpdateRequest = (data) => {
  return {
    type: INVOICE_DRAFT_UPDATE_REQUEST,
    payload: data,
  };
};
//INVOICE_DRAFT_UPDATE_SUCCESS
export const invoiceDraftUpdateSuccess = (data) => {
  return {
    type: INVOICE_DRAFT_UPDATE_SUCCESS,
    payload: data,
  };
};
//INVOICE_DRAFT_UPDATE_FAILURE
export const invoiceDraftUpdateFailure = (error) => {
  return {
    type: INVOICE_DRAFT_UPDATE_FAILURE,
    payload: error,
  };
};
//INVOICE_DRAFT_VOID_REQUEST
export const invoiceDraftVoidRequest = (data) => {
  return {
    type: INVOICE_DRAFT_VOID_REQUEST,
    payload: data,
  };
};
//INVOICE_DRAFT_VOID_SUCCESS
export const invoiceDraftVoidSuccess = (data) => {
  return {
    type: INVOICE_DRAFT_VOID_SUCCESS,
    payload: data,
  };
};
//INVOICE_DRAFT_VOID_FAILURE
export const invoiceDraftVoidFailure = (error) => {
  return {
    type: INVOICE_DRAFT_VOID_FAILURE,
    payload: error,
  };
};
//INVOICE_DRAFT_PDF_REQUEST
export const invoiceDraftPdfRequest = (data) => {
  return {
    type: INVOICE_DRAFT_PDF_REQUEST,
    payload: data,
  };
};
//INVOICE_DRAFT_PDF_SUCCESS
export const invoiceDraftPdfSuccess = (data) => {
  return {
    type: INVOICE_DRAFT_PDF_SUCCESS,
    payload: data,
  };
};
//INVOICE_DRAFT_PDF_FAILURE
export const invoiceDraftPdfFailure = (error) => {
  return {
    type: INVOICE_DRAFT_PDF_FAILURE,
    payload: error,
  };
};
//INVOICE_DRAFT_DAILY_BALANCE_REQUEST
export const invoiceDraftDailyBalanceRequest = (data) => {
  return {
    type: INVOICE_DRAFT_DAILY_BALANCE_REQUEST,
    payload: data,
  };
};
//INVOICE_DRAFT_DAILY_BALANCE_SUCCESS
export const invoiceDraftDailyBalanceSuccess = (data) => {
  return {
    type: INVOICE_DRAFT_DAILY_BALANCE_SUCCESS,
    payload: data,
  };
};
//INVOICE_DRAFT_DAILY_BALANCE_FAILURE
export const invoiceDraftDailyBalanceFailure = (error) => {
  return {
    type: INVOICE_DRAFT_DAILY_BALANCE_FAILURE,
    payload: error,
  };
};
//INVOICE_DRAFT_STATUS_LIST_REQUEST
export const invoiceDraftStatusListRequest = () => {
  return {
    type: INVOICE_DRAFT_STATUS_LIST_REQUEST,
  };
};
//INVOICE_DRAFT_STATUS_LIST_SUCCESS
export const invoiceDraftStatusListSuccess = (data) => {
  return {
    type: INVOICE_DRAFT_STATUS_LIST_SUCCESS,
    payload: data,
  };
};
//INVOICE_DRAFT_STATUS_LIST_FAILURE
export const invoiceDraftStatusListFailure = (error) => {
  return {
    type: INVOICE_DRAFT_STATUS_LIST_FAILURE,
    payload: error,
  };
};
//INVOICE_DRAFT_STATUS_DATA_REQUEST
export const invoiceDraftStatusDataRequest = (data) => {
  return {
    type: INVOICE_DRAFT_STATUS_DATA_REQUEST,
    payload: data,
  };
};
//INVOICE_DRAFT_STATUS_DATA_SUCCESS
export const invoiceDraftStatusDataSuccess = (data) => {
  return {
    type: INVOICE_DRAFT_STATUS_DATA_SUCCESS,
    payload: data,
  };
};
//INVOICE_DRAFT_STATUS_DATA_FAILURE
export const invoiceDraftStatusDataFailure = (error) => {
  return {
    type: INVOICE_DRAFT_STATUS_DATA_FAILURE,
    payload: error,
  };
};
//INVOICE_DRAFT_STATUS_CREATE_REQUEST
export const invoiceDraftStatusCreateRequest = (data) => {
  return {
    type: INVOICE_DRAFT_STATUS_CREATE_REQUEST,
    payload: data,
  };
};
//INVOICE_DRAFT_STATUS_CREATE_SUCCESS
export const invoiceDraftStatusCreateSuccess = (data) => {
  return {
    type: INVOICE_DRAFT_STATUS_CREATE_SUCCESS,
    payload: data,
  };
};
//INVOICE_DRAFT_STATUS_CREATE_FAILURE
export const invoiceDraftStatusCreateFailure = (error) => {
  return {
    type: INVOICE_DRAFT_STATUS_CREATE_FAILURE,
    payload: error,
  };
};
//INVOICE_DRAFT_STATUS_UPDATE_REQUEST
export const invoiceDraftStatusUpdateRequest = (data) => {
  return {
    type: INVOICE_DRAFT_STATUS_UPDATE_REQUEST,
    payload: data,
  };
};
//INVOICE_DRAFT_STATUS_UPDATE_SUCCESS
export const invoiceDraftStatusUpdateSuccess = (data) => {
  return {
    type: INVOICE_DRAFT_STATUS_UPDATE_SUCCESS,
    payload: data,
  };
};
//INVOICE_DRAFT_STATUS_UPDATE_FAILURE
export const invoiceDraftStatusUpdateFailure = (error) => {
  return {
    type: INVOICE_DRAFT_STATUS_UPDATE_FAILURE,
    payload: error,
  };
};
//INVOICE_DRAFT_STATUS_DELETE_REQUEST
export const invoiceDraftStatusDeleteRequest = (data) => {
  return {
    type: INVOICE_DRAFT_STATUS_DELETE_REQUEST,
    payload: data,
  };
};
//INVOICE_DRAFT_STATUS_DELETE_SUCCESS
export const invoiceDraftStatusDeleteSuccess = (data) => {
  return {
    type: INVOICE_DRAFT_STATUS_DELETE_SUCCESS,
    payload: data,
  };
};
//INVOICE_DRAFT_STATUS_DELETE_FAILURE
export const invoiceDraftStatusDeleteFailure = (error) => {
  return {
    type: INVOICE_DRAFT_STATUS_DELETE_FAILURE,
    payload: error,
  };
};

//INVOICE_DRAFT_DATA_REQUEST
export const invoiceDraftDataRequest = (data) => {
  return {
    type: INVOICE_DRAFT_DATA_REQUEST,
    payload: data,
  };
};
//INVOICE_DRAFT_DATA_SUCCESS
export const invoiceDraftDataSuccess = (data) => {
  return {
    type: INVOICE_DRAFT_DATA_SUCCESS,
    payload: data,
  };
};
//INVOICE_DRAFT_DATA_FAILURE
export const invoiceDraftDataFailure = (error) => {
  return {
    type: INVOICE_DRAFT_DATA_FAILURE,
    payload: error,
  };
};

//INVOICE_DRAFT_ACTIVITY_LOG_SEARCH_REQUEST
export const invoiceDraftActivityLogSearchRequest = (data) => {
  return {
    type: INVOICE_DRAFT_ACTIVITY_LOG_SEARCH_REQUEST,
    payload: data,
  };
};
//INVOICE_DRAFT_ACTIVITY_LOG_SEARCH_SUCCESS
export const invoiceDraftActivityLogSearchSuccess = (data) => {
  return {
    type: INVOICE_DRAFT_ACTIVITY_LOG_SEARCH_SUCCESS,
    payload: data,
  };
};
//INVOICE_DRAFT_ACTIVITY_LOG_SEARCH_FAILURE
export const invoiceDraftActivityLogSearchFailure = (error) => {
  return {
    type: INVOICE_DRAFT_ACTIVITY_LOG_SEARCH_FAILURE,
    payload: error,
  };
};

//INVOICE_DRAFT_CONVERT_TO_INVOICE_REQUEST
export const invoiceDraftConvertToInvoiceRequest = (data) => {
  return {
    type: INVOICE_DRAFT_CONVERT_TO_INVOICE_REQUEST,
    payload: data,
  };
};
//INVOICE_DRAFT_CONVERT_TO_INVOICE_SUCCESS
export const invoiceDraftConvertToInvoiceSuccess = (data) => {
  return {
    type: INVOICE_DRAFT_CONVERT_TO_INVOICE_SUCCESS,
    payload: data,
  };
};
//INVOICE_DRAFT_CONVERT_TO_INVOICE_FAILURE
export const invoiceDraftConvertToInvoiceFailure = (error) => {
  return {
    type: INVOICE_DRAFT_CONVERT_TO_INVOICE_FAILURE,
    payload: error,
  };
};
